import type { FunctionComponent } from 'react'
import React from 'react'
import { DateTime, TypographyV2 as Typography } from '@which/seatbelt'

import classnames from 'classnames'

import type { ReviewsAdviceSingleArticleData } from '../../ReviewsAdviceSinglePage'
import styles from './Header.module.scss'

const newsArticle = 'newsArticle' as const

type Props = ReviewsAdviceSingleArticleData['header'] & {
  type?: typeof newsArticle
}
export const Header: FunctionComponent<Props> = ({
  addMarginOffsetClass,
  date,
  headline,
  standfirst,
  type,
}) => {
  return (
    <div className={styles.wHeaderWrapper}>
      <div
        className={classnames(styles.wInnerWrapper, type && styles[type])}
        data-testid="inner-wrapper"
      >
        {date?.rendered && (
          <div className={styles.wHeaderWrapperDate} data-testid="article-date">
            <DateTime dateInput={date.iso} showDateOrTime={'Date'} />
          </div>
        )}

        {headline && (
          <Typography
            className={styles.headline}
            dataTestId="headline"
            tag="h1"
            textStyle="sb-text-heading-page-title"
          >
            {headline}
          </Typography>
        )}

        {standfirst && (
          <div
            data-testid="standfirst-wrapper"
            className={classnames(styles.wHeaderStandfirst, {
              [styles.wHeaderStandfirstMarginOffset]: addMarginOffsetClass,
            })}
          >
            <Typography data-testid="standfirst" tag="span" textStyle="sb-text-heading-standfirst">
              {standfirst}
            </Typography>
          </div>
        )}
      </div>
    </div>
  )
}
